/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import {
    Button,
    Dialog,
    DialogTitle,
    // DialogActions,
    DialogContent,
    Grid,
    TextField,
    FormControlLabel,
    Checkbox,
} from '@material-ui/core';
import { AnyObject, Field, Form, FormSpy } from 'react-final-form';
import { FormApi } from 'final-form';
import { RvLoader } from '../../components/Loader';
import { IAutoCompleteItem } from '../../typings/autoComplete';
import DialogBox from '../../Dashboard/Component/DialogBox';
import { ExternalEmailTemplateSelector } from '../selectors/ExternalEmailTemplateSelector';
import { EmailTemplateTypeEnum } from '../EmailTemplateRespository';
import { showNotification } from '../../App';
import { EmailStyle } from '../tabs/NewEnquiryResponseTemplateTab';
import { FetchPolicy } from 'apollo-client';
import { client } from '../..';
import gql from 'graphql-tag';
import { UserFeature, UserFeatureEnum } from '../../types/UserFeature';
import { AvailableAreaOfLawSelector } from '../selectors/AvailableAreaOfLawSelector';
import { Alert } from '@material-ui/lab';
import { EditorWrapper } from '../../components/Editor';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        dialogRoot: {
            '& .downshift-wrapper': {
                flex: 1,
                padding: 0,
            }
        },
        dialogPaper: {
            height: '100%',
        },
        form: {
            display: 'flex',
            flexFlow: 'column',
            flex: 1,
        },
        header: {
            textTransform: 'capitalize',
            '& .MuiTypography-root': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
            }
        },
        textField: {
            width: '100%',
        },
        content: {
            flex: 1
        },
        buttonContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            // paddingBottom: '20px'
        },
        button: {
            margin: theme.spacing(1),
            minWidth: '83px',
        },
        hidden: {
            display: 'none',
        },
        loaderWrapper: {
            display: 'flex',
            justifyContent: 'center',
            padding: '20px 0',
        },
        clientSelector: {
            flex: 1
        },
        wrapperClassName: {
            display: 'flex',
            flexFlow: 'column',
            flex: 1,
            minHeight: 300,
        },
        toolbarClassName: {
            backgroundColor: '#fafbff',
        },
        editorClassName: {
            border: '1px solid #F1F1F1',
            padding: '0 10px',
            flex: 1,
        },
        formControlLabel: {
            marginLeft: 0,
            marginRight: 0,
        },
    })
);

interface NewEnquiryResponseDialogProps {
    open: boolean;
    onClose?: () => void;
    title: string;
    emailType: EmailTemplateTypeEnum;
    integrationTemplateId: string | null;
    emailStyle: number | null;
    areaOfLaw: IAutoCompleteItem | null;
    // tslint:disable-next-line: no-any
    externalTemplate: IAutoCompleteItem | null | any;
    emailTemplateGuid: string | null;
    // tslint:disable-next-line: no-any
    selectedData: any | null;
    // tslint:disable-next-line: no-any
    onDataChanged?: (selectedData: any | null) => void;
    isAllExists: boolean;
    isAllExistsGuid: string | null;
}

interface NewEnquiryResponseDialogState {
    open: boolean;
    isLoading: boolean;
    onSubmitLoading: boolean;
    showDiscard: boolean;
    isChanged: boolean;
    isExternalTemplate: boolean;
    isTemplateLoading: boolean;
}

interface NewEqnuiryResponseForm {
    areaOfLaw: IAutoCompleteItem | null;
    // tslint:disable-next-line: no-any
    externalTemplate: IAutoCompleteItem | null | any;
    template: string | null;
    subject: string | null;
    emailType: string | null; 
    emailStyle: string | null;
    editorState: string;
    // tslint:disable-next-line: no-any
    matchedProperties: any;
    integrationTemplateId: string | null;
    isAllExists: boolean;
    isAllExistsGuid: string | null;
    isActive: boolean;
}

export const NewEnquiryResponseDialog: React.FC<NewEnquiryResponseDialogProps> = (props) => {
    const classes = useStyles();

    const [state, setState] = useState<NewEnquiryResponseDialogState>({
        open: false,
        isLoading: false,
        onSubmitLoading: false,
        showDiscard: false,
        isChanged: false,
        isExternalTemplate: false,
        isTemplateLoading: false
    });

    const [newEqnuiryResponseForm, setNewEqnuiryResponseForm] = useState<NewEqnuiryResponseForm>({
        areaOfLaw: props.areaOfLaw,
        externalTemplate: props.externalTemplate,
        template: null,
        subject: null,
        emailType: null, 
        emailStyle: null,
        // tslint:disable-next-line: no-any
        matchedProperties: null,
        integrationTemplateId: null,
        editorState: '',
        isAllExists: props.isAllExists,
        isAllExistsGuid: props.isAllExistsGuid,
        isActive: false
    });

    let countFetching = 0;

    useEffect(() => {

        // if (props.emailTemplateGuid) {
        fetchEmailTemplate(
            props.emailStyle, 
            props.integrationTemplateId, 
            props.areaOfLaw
        );
        // }
        
        setState((prevState) => {
            return {
                ...prevState,
                open: props.open
            };
        });
    // tslint:disable-next-line: align
    }, [props.open, props.emailStyle, props.integrationTemplateId]);

    const onSubmit = (form: FormApi<NewEqnuiryResponseForm>, values: AnyObject) => {
                
        const properties = [];

        if (values.areaOfLaw) {
            properties.push({
                key: values.areaOfLaw.value,
            });
        }

        const matchedPropertyInput = {
            entity: 'areaOfLaw',
            properties: properties
        };

        setState((prevState) => {
            return {
                ...prevState,
                onSubmitLoading: true
            };
        });
        
        client.mutate({
            mutation: UpdateEmailTemplate,
            variables: {
                isInternalRole: null,
                roleId: null,
                selectedUserId: null,
                template: state.isExternalTemplate ? values.template : values.editorState,
                emailType: EmailTemplateTypeEnum[props.emailType], 
                subject: values.subject && values.subject.length > 0 ? values.subject : null,
                matchedProperties: matchedPropertyInput,
                integrationTemplateId: values.integrationTemplateId ? values.integrationTemplateId : null,
                emailStyle: values.emailStyle ? values.emailStyle : null,
                emailTemplateGuid: props.emailTemplateGuid ? props.emailTemplateGuid : null,
                isActive: values.isActive
                // JSON.stringify(state.editorState)
            }
        })
        // tslint:disable-next-line: no-any
        .then((results: { data: any }) => {
            if (results.data) {
                if (results.data.error === null || results.data.error === undefined) {
                    showNotification(null, 'Successfully submitted', 'info');

                    const prevSelectedDataFromTable = {
                        ...props.selectedData,
                        emailStyle: values.externalTemplate ? values.externalTemplate.emailStyle : EmailStyle.HTML,
                        integrationTemplateId:  values.externalTemplate ? values.externalTemplate.externalTemplateId : null,
                        integrationTemplateName: values.externalTemplate ? values.externalTemplate.templateName : null,
                        areaOfLaw: values.areaOfLaw ? values.areaOfLaw : null,
                        externalTemplate: values.externalTemplate ? values.externalTemplate : null,
                        emailTemplateGuid: props.selectedData ? props.selectedData.emailTemplateGuid : null,
                        isActive: values.isActive
                    };
            
                    if (props.onDataChanged) {
                        props.onDataChanged(prevSelectedDataFromTable);
                    }

                    if (props.onClose) {
                        props.onClose();
                    }

                    setState((prevState) => {
                        return {
                            ...prevState,
                            isLoading: false,
                            onSubmitLoading: false
                        };
                    });

                } else {
                    showNotification('Failed to save email template', results.data.error, 'error');

                    setState((prevState) => {
                        return {
                            ...prevState,
                            onSubmitLoading: false
                        };
                    });

                }
            }
        })
        // tslint:disable-next-line:no-any
        .catch((reason: any) => {
            showNotification('Failed to Save email template', reason, 'error');
            setState((prevState) => {
                return {
                    ...prevState,
                    onSubmitLoading: false
                };
            });
        });

    };

    const closePanel = () => {
        // codepanel
        if (props.onClose) {
            return props.onClose();
        }
    };

    const onReset = () => {
        // reset
    };

    // tslint:disable-next-line: no-any
    const onFormValueChanged = (form: FormApi<NewEqnuiryResponseForm>, changeProps: any) => {

        if (!changeProps.pristine) {
            setState((prevState) => {
                return {
                    ...prevState,
                    isChanged: true
                };
            });
        }
    };

    const onClose = () => {
        if (state.isChanged) {
            setState((prevState) => {
                return {
                    ...prevState,
                    showDiscard: true
                };
            });
        } else {
            if (props.onClose) {
                props.onClose();
            }
        }
    };

    const onDiscardChanges = (agree: boolean) => {
        if (agree) {
            setState((prevState) => {
                return {
                    ...prevState,
                    showDiscard: false,
                };
            });

            if (props.onClose) {
                props.onClose();
            }

        } else {
           setState((prevState) => {
               return {
                   ...prevState,
                   showDiscard: false
               };
           });
        }
    };

    const fetchEmailTemplate = (emailStyle: number | null, integrationTemplateId: string | null, 
                                areaOfLaw: IAutoCompleteItem | null, formApi?: FormApi<NewEqnuiryResponseForm>,
                                values?: AnyObject) => {
        
        setState((prevState) => {
            return {
                ...prevState,
                isTemplateLoading: true
            };
        });

        // tslint:disable-next-line: no-any
        let emailStyleNew: any = emailStyle;
        if (emailStyle !== null ) {
            if (isNaN(emailStyle)) {
                emailStyleNew = EmailStyle[emailStyle];
            }
            
        }

        let emailTemplateQueryParams: EmailTemplateQueryParams = {
            isInternalRole: null,
            roleId: null,
            selectedUserId: null,
            emailType: EmailTemplateTypeEnum[props.emailType],
            emailStyle: emailStyle !== null ? EmailStyle[emailStyleNew] : EmailStyle[EmailStyle.HTML],
            integrationTemplateId: integrationTemplateId ? integrationTemplateId : null,
            areaOfLaw: areaOfLaw ? areaOfLaw.label : null,
            emailTemplateGuid: props.emailTemplateGuid ? props.emailTemplateGuid : null
        };

        retrieveEmailTemplateData(
            emailTemplateQueryParams,
            true,
            // tslint:disable-next-line: no-any
            (data: any) => onDataRetrieved(data, emailStyle, integrationTemplateId, areaOfLaw, formApi, values),
            // tslint:disable-next-line:no-any
            function (reason: any): void {
              showNotification(null, reason, 'error');
        });
    };

    const onDataRetrieved = (data: EmailTemplateData, emailStyle: number | null, integrationTemplateId: string | null, 
                             areaOfLaw: IAutoCompleteItem | null, formApi?: FormApi<NewEqnuiryResponseForm>, values?: AnyObject) => {
        
        // let templateValue = values?.template;
        
        if (data.templates !== null && data.templates.emailTemplate !== null && data.templates.emailTemplate.template !== null) {

            const emailTemplate = data.templates.emailTemplate;

            const matchedPropertyInput = {
                entity: 'areaOfLaw',
                properties: emailTemplate.matchedPropertys.matchedProperty
            };

            // const contentBlock = htmlToDraft(emailTemplate.template && emailTemplate.template !== ''
            //     ? emailTemplate.template 
            //     : templateValue
            // );

            if (formApi) {                
                formApi.batch(() => {
                    if (emailTemplate.subject && emailTemplate.subject.length > 0) {
                        formApi.change('subject', emailTemplate.subject);
                    }
                    if (emailTemplate.template && emailTemplate.template.length > 0) {
                        formApi.change('editorState', emailTemplate.template);
                    }
                    formApi.change('template', emailTemplate.template);
                    // formApi.change('template', emailTemplate.template && emailTemplate.template.length === 0 
                    //     ? templateValue
                    //     : emailTemplate.template);
                    formApi.change('emailStyle', emailTemplate.emailStyle ? EmailStyle[emailTemplate.emailStyle] : null);
                    formApi.change('matchedProperties', matchedPropertyInput);
                    formApi.change('integrationTemplateId', emailTemplate.integrationTemplateId);
                    formApi.change('isActive', emailTemplate.isActive);
                }); 
            } else {                
                setNewEqnuiryResponseForm((prevNewEqnuiryResponseForm) => {
                    return {
                        ...prevNewEqnuiryResponseForm,
                        template: emailTemplate.template,
                        subject: emailTemplate.subject && emailTemplate.subject.length > 0 ? emailTemplate.subject : prevNewEqnuiryResponseForm.subject,
                        emailStyle: emailTemplate.emailStyle ? EmailStyle[emailTemplate.emailStyle] : null,
                        matchedProperties: matchedPropertyInput,
                        integrationTemplateId: emailTemplate.integrationTemplateId,
                        editorState: emailTemplate.template && emailTemplate.template.length > 0 ? emailTemplate.template : prevNewEqnuiryResponseForm.editorState,
                        isActive: emailTemplate.isActive
                    };
                });
            }

            setState((prevState) => {
                return {
                    ...prevState,
                    isExternalTemplate: emailTemplate.emailStyle > 1,
                    isTemplateLoading: false,
                    isLoading: false,
                };
            });

        } else if (data.templates !== null && data.templates.emailTemplate !== null && data.templates.emailTemplate.template === null) {
            if (countFetching < 1) {
                // tslint:disable-next-line: no-console
                console.log('refetch');
                fetchEmailTemplate(emailStyle, integrationTemplateId, null, formApi, values);
            } else if (countFetching < 2) {
                // tslint:disable-next-line: no-console
                console.log('fetch default');
                fetchEmailTemplate(null, null, null, formApi, values);
            } else {
                
                setState((prevState) => {
                    return {
                        ...prevState,
                        isTemplateLoading: false,
                        isLoading: false,
                    };
                });
            }
            countFetching += 1;            
        }
    };

    // tslint:disable-next-line: no-any
    const required = (value: any) => {
        return value ? undefined : 'Required';
    };

    const actionButton = (
        // tslint:disable-next-line: no-any
        form: FormApi<NewEqnuiryResponseForm>,
        submitting: boolean,
        pristine: boolean,
        // tslint:disable-next-line: no-any
        values: AnyObject
    ) => {
        return (
            <div className={classes.buttonContainer}>
                {/* <RenderCount /> */}
                <div>
                    <Button
                        color="primary"
                        type="submit"
                        className={classes.button}
                        onClick={() => {
                            // code here..
                        }}
                        disabled={submitting || pristine || state.onSubmitLoading || 
                            (values.isAllExists && values.isAllExistsGuid !== props.emailTemplateGuid && values.areaOfLaw === null 
                        )}
                    >
                        Save
                    </Button>
                </div>
                <div>
                    <Button
                        id="resetButton"
                        type="button"
                        onClick={onReset}
                        disabled={submitting || pristine}
                        className={classes.hidden}
                    >
                        Reset
                    </Button>
                    <Button
                        color="primary"
                        type="button"
                        className={classes.button}
                        onClick={closePanel}
                    >
                        Cancel
                    </Button>
                </div>
            </div>
        );
    };

    return (
        <>
            <DialogBox
                title="Template"
                // tslint:disable-next-line:max-line-length
                content={`Are you sure you want to close the form?`}
                show={state.showDiscard}
                isAgree={onDiscardChanges}
                disAgreeLabel={'No'}
                agreeLabel={'Yes'}
            />
            
            <Dialog
                open={state.open}
                onClose={onClose}
                maxWidth="lg"
                fullWidth={true}
                className={classes.dialogRoot}
                disableEnforceFocus={true}
                scroll={'paper'}
                classes={{
                    // paper: classes.dialogPaper
                }}
            >
                {state.isLoading ? (
                    <>
                        <DialogTitle className={classes.header}>{props.title}</DialogTitle>
                        <DialogContent dividers={true}>
                            <div className={classes.loaderWrapper}>
                                <RvLoader size="small" label="Loading..."/>
                            </div>
                        </DialogContent>
                    </>
                ) : (
                    <Form
                        onSubmit={(values, form: FormApi<NewEqnuiryResponseForm>) => onSubmit(form, values)}                
                        initialValues={newEqnuiryResponseForm}
                        subscription={{ submitting: true, pristine: true }}
                        render={({handleSubmit, form, submitting, pristine, values}) => (
                            <form onSubmit={handleSubmit} id="taskForm" className={classes.form}>
                                <FormSpy 
                                    subscription={{ pristine: true, values: true }}
                                    // tslint:disable-next-line: no-shadowed-variable
                                    onChange={props => {
                                        onFormValueChanged(form, props);
                                    }}
                                />
                                <DialogTitle className={classes.header}>
                                    <div>{props.title}</div>
                                    <FormSpy subscription={{ values: true }}>
                                        {/* tslint:disable-next-line: no-shadowed-variable */}
                                        {({ values }) => ( 
                                            actionButton(form, submitting, pristine, values)
                                        )}
                                    </FormSpy>
                                   
                                </DialogTitle>
                                <DialogContent dividers={true}>                                    
                                    <Grid container={true} spacing={3}> 
                                        <Grid item={true} xs={12}>
                                            <FormSpy subscription={{ values: true }}>
                                                {/* tslint:disable-next-line: no-shadowed-variable */}
                                                {({ values }) => (
                                                    values.isAllExists && values.isAllExistsGuid !== props.emailTemplateGuid 
                                                    && values.areaOfLaw === null && (
                                                        <div>
                                                            <Alert severity="warning">        
                                                                {/* tslint:disable-next-line: max-line-length */}
                                                                There can only be one template for all areas of law.
                                                            </Alert>
                                                        </div>
                                                    )
                                                )}
                                            </FormSpy>
                                        </Grid>                                      
                                        <Grid item={true} xs={12} md={6}>
                                            <FormSpy subscription={{values: true, validating: true}}>
                                            {/* tslint:disable-next-line: no-shadowed-variable */}
                                                {({ values }) => (
                                                    <Field
                                                        name="areaOfLaw"
                                                        // validate={form.getFieldState('areaOfLaw')?.value !== null ? required : undefined}
                                                    >
                                                        {({ input, meta }) => (
                                                            <AvailableAreaOfLawSelector
                                                                {...input}
                                                                emailType={props.emailType}
                                                                name="areaOfLaw"
                                                                label="Area Of Law"
                                                                value={input.value ? input.value : undefined}
                                                                // disabled={props.emailTemplateGuid ? true : false}
                                                                disablePortal={false}
                                                                // required={true}
                                                                className={`${classes.textField} ${classes.clientSelector}`}
                                                                error={meta.error && meta.touched}
                                                                    // tslint:disable-next-line: jsx-alignment
                                                                onSelection={(selection: IAutoCompleteItem, name: string) => {
                                                                    fetchEmailTemplate(
                                                                        values.emailStyle ? values.emailStyle : null, 
                                                                        values.externalTemplate ? values.externalTemplate.value : null, 
                                                                        selection ? selection : null,
                                                                        form,
                                                                        values
                                                                    );
                                                                    input.onChange(selection);

                                                                    if (selection) {
                                                                        form.change('isAllExists', false);
                                                                        form.change('isAllExistsGuid', null);
                                                                    } else {
                                                                        form.change('isAllExists', props.isAllExists);
                                                                        form.change('isAllExistsGuid', props.isAllExistsGuid);
                                                                    }                                                                    
                                                                }}
                                                                helperText={
                                                                    meta.error &&
                                                                    meta.touched
                                                                        ? 'Assigned to is required'
                                                                        : ''
                                                                }
                                                            />
                                                        )}
                                                    </Field>
                                                )}
                                            </FormSpy>
                                        </Grid>
                                        {!!UserFeature.HasAccess(UserFeatureEnum.hasVisionSix) && (
                                            <Grid item={true} xs={12} md={6}>
                                                <FormSpy 
                                                    subscription={{ 
                                                        values: true, 
                                                        validating: true,
                                                    }}
                                                >
                                                {/* tslint:disable-next-line: no-shadowed-variable */}
                                                    {({ values }) => (
                                                        <Field
                                                            name="externalTemplate"
                                                        >
                                                            {({ input, meta }) => (
                                                                <ExternalEmailTemplateSelector
                                                                    {...input}
                                                                    name="externalTemplate"
                                                                    label="External Template"
                                                                    value={input.value ? input.value : undefined}
                                                                    disablePortal={false}
                                                                    // required={true}
                                                                    className={`${classes.textField} ${classes.clientSelector}`}
                                                                    error={meta.error && meta.touched}
                                                                    // tslint:disable-next-line: jsx-alignment no-any
                                                                    onSelection={(selection: IAutoCompleteItem | any, name: string) => {
                                                                        fetchEmailTemplate(
                                                                            selection ? selection.emailStyle : null, 
                                                                            selection ? selection.externalTemplateId : null, 
                                                                            values.areaOfLaw ? values.areaOfLaw : null,
                                                                            form,
                                                                            values
                                                                        );
                                                                        input.onChange(selection);
                                                                    }}
                                                                    helperText={
                                                                        meta.error &&
                                                                        meta.touched
                                                                            ? 'Assigned by is required'
                                                                            : ''
                                                                    }
                                                                />
                                                            )}
                                                        </Field>
                                                    )}
                                                </FormSpy>
                                            </Grid>
                                        )}
                                        <Grid item={true} xs={12} md={12}>
                                            <Grid container={true} spacing={3}>
                                                {state.isTemplateLoading ? (
                                                    <Grid item={true} xs={12} md={12}>
                                                        <div className={classes.loaderWrapper}>
                                                            <RvLoader size="small" label="Loading..."/>
                                                        </div>
                                                    </Grid>
                                                ) : (
                                                    <>
                                                        <Grid item={true} xs={12} md={6}>
                                                            <Field
                                                                name="subject"
                                                                subscription={{touched: true, error: true, value: true}}
                                                                validate={required}
                                                            >
                                                                {({ input, meta }) => (
                                                                    <TextField
                                                                        {...input}
                                                                        label="Subject"
                                                                        type="text"
                                                                        required={true}
                                                                        className={classes.textField}
                                                                        error={meta.error && meta.touched}
                                                                        helperText={
                                                                            meta.error &&
                                                                            meta.touched
                                                                                ? 'Subject is required'
                                                                                : ''
                                                                        }
                                                                        InputProps={{
                                                                            readOnly: state.isExternalTemplate
                                                                        }}
                                                                    />
                                                                )}
                                                            </Field>
                                                        </Grid>
                                                        <Grid item={true} xs={12} md={6}>
                                                            <Field
                                                                name="isActive"
                                                                subscription={{touched: true, error: true, value: true}}
                                                            >                                            
                                                                {({ input, meta }) => (
                                                                    <FormControlLabel
                                                                        className={classes.formControlLabel}
                                                                        control={
                                                                            <Checkbox
                                                                                {...input}
                                                                                checked={input.value}
                                                                                onChange={input.onChange}
                                                                                checkedIcon={<CheckBoxIcon color="primary" />}
                                                                            />
                                                                        }
                                                                        label="Active"
                                                                    />
                                                                )}
                                                            </Field>
                                                        </Grid>
                                                        {state.isExternalTemplate ? (
                                                            <Grid item={true} xs={12} md={12}>
                                                                <Field
                                                                    name="template"
                                                                    subscription={{touched: true, error: true, value: true}}
                                                                    // validate={required}
                                                                >
                                                                    {({ input, meta }) => (
                                                                        <div
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: input.value
                                                                            }}
                                                                        />
                                                                    )}
                                                                </Field>
                                                            </Grid>
                                                        ) : (
                                                            <Grid item={true} xs={12} md={12}>
                                                                <Field
                                                                    name="editorState"
                                                                    subscription={{touched: true, error: true, value: true}}
                                                                    // validate={required}
                                                                >
                                                                    {({ input, meta }) => {
                                                                            
                                                                        return (
                                                                            <EditorWrapper 
                                                                                value={input.value}
                                                                                onEditorChange={(content: string) => {
                                                                                    input.onChange(content);
                                                                                }}
                                                                                emailType={props.emailType}
                                                                            />
                                                                        );
                                                                    }}
                                                                </Field>
                                                            </Grid>
                                                        )}
                                                    </>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    {/* {printJson(values)} */}
                                </DialogContent>
                                {/* <DialogActions>
                                    {actionButton(form, submitting, pristine, values)}
                                </DialogActions> */}
                            </form>
                        )} 
                    />
                )}
            </Dialog>
        </>
    );
};

// tslint:disable-next-line: no-any
export function printJson(values: any) {
    if (values) {
        return (
            <>
                <pre>
                    {JSON.stringify(values, undefined, 2)}
                </pre>
            </>
        );
    } else {
        return (
            <>
                <FormSpy subscription={{ values: true }}>
                    {/* tslint:disable-next-line: no-shadowed-variable */}
                    {({ values }) => (
                        <pre>
                            {JSON.stringify(values, undefined, 2)}
                            {/* <RenderCount /> */}
                        </pre>
                    )}
                </FormSpy>
            </>
        );
    }
}

export interface EmailTemplateQueryParams {
    isInternalRole: boolean | null;
    roleId: string | null;
    selectedUserId: string | null; 
    emailType: string | null;
    emailStyle: string | null;
    integrationTemplateId: string | null;  
    areaOfLaw: string | null;
    emailTemplateGuid: string | null;
}

export interface EmailTemplateData {
    loading?: boolean;
    networkStatus?: number;
    templates: Templates;
}

export interface Templates {
    emailTemplate: EmailTemplate;
}

export interface EmailTemplate {
    emailTemplateGuid: string;
    emailType:         number;
    isInternalRole:    null;
    roleGuid:          null;
    subject:           string;
    template:          string;
    emailStyle:        number;
    userGuid:          null;
    ccAssistant:       boolean;
    matchedPropertys:  MatchedPropertys;
    integrationTemplateId: string;
    isActive: boolean;
}
export interface MatchedPropertys {
    entity:          string;
    matchedProperty: MatchedProperty[];
}
export interface MatchedProperty {
    key:                  string;
    keyDescription:       string;
    recipient:            string;
    recipientDescription: string;
    scope:                string;
    scopeDescription:     string;
}

export function retrieveEmailTemplateData(
    query: EmailTemplateQueryParams, 
    refreshData: boolean,
    onSuccess: (data: EmailTemplateData) => void,
    // tslint:disable-next-line:no-any
    onError: (reason: any) => void)
     : void {
        var fetchPolicy: FetchPolicy = refreshData === true ? 'network-only' : 'cache-first';
        client.query({
            query: EmailTemplateQuery,
            variables: {
                isInternalRole: query.isInternalRole,
                roleId: query.roleId,
                selectedUserId: query.selectedUserId,
                emailType: query.emailType,
                emailStyle: query.emailStyle,
                integrationTemplateId: query.integrationTemplateId,
                areaOfLaw: query.areaOfLaw,
                emailTemplateGuid: query.emailTemplateGuid
            },
            fetchPolicy: fetchPolicy
    })
    // tslint:disable-next-line:no-any
    .then((results: { data: any; }) => {
        onSuccess(results.data);
    })
    // tslint:disable-next-line:no-any
    .catch((reason: any ) => { 
        onError(reason); 
    });
}

const EmailTemplateQuery = gql`
    query EmailTemplate(
        $isInternalRole: Boolean, 
        $roleId: String, 
        $selectedUserId: String, 
        $emailType: EmailType,
        $emailStyle: EmailStyle,
        $integrationTemplateId: String,
        $areaOfLaw: String,
        $emailTemplateGuid: String
    ) {
        templates {
        emailTemplate(
            isInternalRole: $isInternalRole, 
            roleId: $roleId, 
            selectedUserId: $selectedUserId, 
            emailType: $emailType,
            emailStyle: $emailStyle,
            integrationTemplateId: $integrationTemplateId,
            areaOfLaw: $areaOfLaw,
            emailTemplateGuid: $emailTemplateGuid
        )   {
                emailTemplateGuid
                emailType
                isInternalRole
                roleGuid
                subject
                template
                emailStyle
                userGuid
                ccAssistant
                integrationTemplateId
                isActive
                matchedPropertys {
                    entity
                    matchedProperty {
                        key
                        keyDescription
                        recipient
                        recipientDescription
                        scope
                        scopeDescription
                    }
                }
            }
        }
    }
`;

export const UpdateEmailTemplate = gql`
    mutation UpdateEmailTemplate(
        $emailType: EmailType, 
        $emailStyle: EmailStyle,
        $isInternalRole: Boolean, 
        $roleId: String,
        $selectedUserId: String, 
        $template: String, 
        $subject: String,
        $matchedProperties: MatchedPropertiesInput,
        $ccAssistant: Boolean,
        $integrationTemplateId: String,
        $emailTemplateGuid: String,
        $isActive: Boolean
    ){
        updateEmailTemplate(
            emailType: $emailType, 
            emailStyle: $emailStyle,
            isInternalRole: $isInternalRole, 
            roleId: $roleId, 
            selectedUserId: $selectedUserId, 
            template: $template, 
            subject: $subject,
            matchedProperties: $matchedProperties,
            ccAssistant: $ccAssistant,
            integrationTemplateId: $integrationTemplateId,
            emailTemplateGuid: $emailTemplateGuid,
            isActive: $isActive
        ) {
            status
            error
        }
    }
`;